import $ from 'jquery';

$(document).ready(() => {
    function slider_vertical() {
        $('.slider-vertical').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow:1,
            slidesToScroll: 1,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 1210,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
                {
                    breakpoint: 766,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false,
                    }
                },
            ]
        });
    }
    slider_vertical()
})

